export function fullName(person: { primaryName: string; secondaryName?: string }): string {
	return person.secondaryName ? `${person.primaryName} ${person.secondaryName}` : person.primaryName;
}
